<template> </template>
<script>
export default {
  name: "accounts-columns",
};
</script>
